// Small banner that highlights pending KYC tenants & recent agent notes on owner/consultant dashboards.
import React from 'react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ShieldCheck, MessageSquare } from 'lucide-react';

export function KycAndNotesBanner({ pendingKyc = 0, recentNotes = [], title = 'Field activity', kycHref }) {
  if (!pendingKyc && recentNotes.length === 0) return null;
  return (
    <Card className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="kyc-notes-banner">
      <div className="rounded-lg border bg-amber-50/40 p-3 flex items-start gap-3">
        <ShieldCheck className="h-5 w-5 text-amber-700 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <div className="text-sm font-semibold">{pendingKyc} tenant KYC pending</div>
          <div className="text-xs text-muted-foreground">Tenants on your properties have pending KYC submissions. Coordinate with the Super-Admin to clear them.</div>
        </div>
      </div>
      <div className="rounded-lg border p-3">
        <div className="flex items-center gap-2 text-sm font-semibold mb-1.5"><MessageSquare className="h-4 w-4" /> Recent field notes</div>
        {recentNotes.length === 0 && (
          <div className="text-xs text-muted-foreground">No recent visit / lead notes from consultants or agents.</div>
        )}
        <div className="space-y-1.5 max-h-[140px] overflow-y-auto">
          {recentNotes.slice(0, 4).map((n) => (
            <div key={n.id} className="text-xs">
              <div className="flex items-center gap-1.5">
                <Badge variant="outline" className="text-[10px] capitalize">{n.note_type}</Badge>
                <span className="text-muted-foreground">{n.author_name} <span className="capitalize">({n.author_role})</span></span>
              </div>
              <div className="line-clamp-2">{n.body}</div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
